/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { CancelDelete } from "../../icons/CancelDelete";
import "./style.css";

export const Xx = ({ className, onClick }) => {
  return (
    <div className={`xx ${className}`}>
      <CancelDelete className="icon-instance-node" onClick={onClick} />
    </div>
  );
};
